export const INDIVIDUAL_THERAPY_FEE = "£50"
export const PATERNITY_THERAPY_FEE = "£60"
export const RELATIONSHIPS_THERAPY_FEE = "£70"
export const SESSION_DURATION = "55 minutes"
